import React from 'react';
import {useNavigate, useParams} from "react-router-dom";
import {UserDetail} from "./user-detail";

const UserDetailPage = React.memo(() => {

    const {id} = useParams();
    let navigate = useNavigate();

    const onClose = () => {
        navigate('/users');
    }

    return (
        <UserDetail id={id} onClose={onClose}/>
    )

});

export default UserDetailPage;